import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export const getServices = async () => {
    const res = await api.get("/Services");

    return res.data;
};

export const useServices = () => {
    return useQuery({
        queryKey: ["services"],
        queryFn: getServices,
        retry: 3,
        staleTime: 1000 * 60,
    });
};

export const getService = async (serviceGuid) => {
    const res = await api.get(`/Services/${serviceGuid}`);

    return res.data;
};

export const useService = (serviceGuid) => {
    return useQuery({
        queryKey: ["service", serviceGuid],
        queryFn: () => getService(serviceGuid),
        enabled: !!serviceGuid,
        retry: 3,
        staleTime: Infinity,
    });
};
